define('services/events/resize-events',[
    // Libs
    'jquery',
    'underscore',
    'backbone',
    'mustache',
    'utils',
    // class
    'src/event-aggregator'
], function(
    // Libs
    $, _, Backbone, Mustache, U,
    // class
    EventAggregator
) {

    var ResizeEvents = _.extend({}, EventAggregator.prototype, {

        resize: function() {
            this.trigger('resize');
        }
    });

    return ResizeEvents;

});

